import http, {configJson} from "./config/http-configs";

export const addRole = (role) => {
    const url = "/manage/role/add"
    return http.post(url, role, configJson)
}

export const updateRole = (role) => {
    const url = "/manage/role/update"
    return http.post(url, role, configJson)
}

export const deleteRole = (roleId) => {
    const url = `/manage/role/delete/${roleId}`
    return http.get(url)
}


export const getRoleById = (roleId) => {
    const url = `/manage/role/list/${roleId}`
    return http.get(url)
}

export const getAllRoleList = () => {
    const url = "/manage/role/list/all"
    return http.get(url)
}
